import { render, staticRenderFns } from "./index_pc.vue?vue&type=template&id=0ccedd50&scoped=true&"
import script from "./index_pc.vue?vue&type=script&lang=js&"
export * from "./index_pc.vue?vue&type=script&lang=js&"
import style0 from "./index_pc.vue?vue&type=style&index=0&id=0ccedd50&lang=less&scoped=true&"
import style1 from "./index_pc.vue?vue&type=style&index=1&id=0ccedd50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccedd50",
  null
  
)

export default component.exports